// extracted by mini-css-extract-plugin
export var iconCircle = "index-module--icon-circle--HSA4o";
export var label = "index-module--label--qN3Xr";
export var link = "index-module--link--olCJI";
export var linkDisabled = "index-module--link-disabled--T1wgZ";
export var list = "index-module--list---qS7v";
export var listItem = "index-module--list-item--obj6f";